import { createSelector } from 'reselect';

import { getState } from '../rootSelector';
import { getSelectedPassengerId } from '../selectedPassengerId/selectors';

export const getSelectedFiltersState = createSelector(getState, state => state.selectedPassengersFilters);

export const getSelectedPassengerFilters = createSelector(
	getSelectedFiltersState,
	getSelectedPassengerId,
	(selectedFilters, selectedPassengerId) => selectedFilters[selectedPassengerId]
);
